<div class="chart-header">
  <div class="label">
    {{ label | translate }}
  </div>
</div>
<mat-spinner *ngIf="!dataLoaded" diameter="40"></mat-spinner>
<div class="canvas-wrp">
  <canvas *ngIf="dataLoaded && data" #canvas width="600" height="500" style="width: 100%"></canvas>
</div>
